import type { AnyColor } from '@atlassian/jira-issue-epic-color-types/src/types.tsx';
import {
	asClassicEpicColor,
	asServerColor,
} from '@atlassian/jira-issue-epic-color/src/common/utils.tsx';
import { MUTATION_GROUP } from './constants.tsx';
import type { JiraColorFieldInput } from './types.tsx';

export const mutateEpicColorField = (
	selectedColor: AnyColor,
	fieldId: string,
): JiraColorFieldInput => ({
	fieldId,
	mutationGroup: MUTATION_GROUP,
	color: {
		name: asClassicEpicColor(selectedColor),
	},
});

export const mutateIssueColorField = (
	selectedColor: AnyColor,
	fieldId: string,
): JiraColorFieldInput => ({
	fieldId,
	mutationGroup: MUTATION_GROUP,
	color: {
		name: asServerColor(selectedColor),
	},
});
